import Instance from "../../../../Axios";

// New Actions for the app

const GetEmailBodyTemplates = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/emailBodyTemplates`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_EMAIL_BODY_TEMPLATES", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetEmailBodyTemplates;
